export const String = [
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBSTR005694.jpg",
    title: "Carlton Nanopulse 66 Badminton String (White)",
    desc: "Carlton Nanopulse 66 Badminton String (White) ",
    price: "500",
    mrp: "299",
    discount: "40% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBSTR005695.jpg",
    title: "Carlton Nanopulse 66 Badminton String (Navy Blue)",
    desc: "Carlton Nanopulse 66 Badminton String (Navy Blue) ",
    price: "500",
    mrp: "299",
    discount: "40% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBSTR005696.jpg",
    title: "Carlton Nanopulse 66 Badminton String (Black)",
    desc: "Carlton Nanopulse 66 Badminton String (Black) ",
    price: "500",
    mrp: "299",
    discount: "40% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBSTR005697.jpg",
    title: "Carlton Nanopulse 66 Badminton String (Dark Red)",
    desc: "Carlton Nanopulse 66 Badminton String (Dark Red) ",
    price: "500",
    mrp: "299",
    discount: "40% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBSTR005698.jpg",
    title: "Carlton Nanopulse 66 Badminton String (Green)",
    desc: "Carlton Nanopulse 66 Badminton String (Green) ",
    price: "500",
    mrp: "299",
    discount: "40% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/HDBDSTBT65.jpg",
    title: "Head Boast 65 Badminton String",
    desc: "Head Boast 65 Badminton String ",
    price: "380",
    mrp: "275",
    discount: "28% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTBG80.jpg",
    title: "YONEX BG 80 Badminton String",
    desc: "\nBG80 : For Speed & Smash!\nThe combination of Yonex original high-intensity nylon multifilament and high-modulus Vectran provides a solid feeling and powerful smash. For hard hitting players. ",
    price: "565",
    mrp: "415",
    discount: "27% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTBG85L.jpg",
    title: "YONEX BG 85 Badminton String",
    desc: "This 0.67mm gauge string made from an advanced high-modulus Vectran fibre and multi braided outer generates great repulsion power with a sharp touch. ",
    price: "600",
    mrp: "425",
    discount: "29% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTNG99L.jpg",
    title: "YONEX Nanogy 99 Badminton String",
    desc: "\nNANOGY 99 String: Yonex original rough braided fibre and a special nylon coating provide maximum bite on the shuttle for enhanced hairpin net shots and cuts. .\nDesigned for control players with a technical style ",
    price: "790",
    mrp: "600",
    discount: "24% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTNG98L.jpg",
    title: "YONEX Nanogy 98 Badminton String",
    desc: "\nNANOGY 98 : Comparable Repulsion to Thinner Strings! Fusion of Nanoscience and High Intensity Multifilament Nylon ",
    price: "640",
    mrp: "500",
    discount: "22% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTBG80PWL.jpg",
    title: "YONEX BG 80 Power Badminton String",
    desc: "\nBG80 Power : For Speed & Power Smash!\nThe combination of Yonex original high-intensity nylon multifilament and high-modulus Vectran provides a solid feeling and powerful smash. For hard hitting players. ",
    price: "695",
    mrp: "525",
    discount: "24% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ynanogy95_1200_1.jpg",
    title: "YONEX NANOGY 95 Badminton String",
    desc: "\nNanogy 95: Ideal for Yonex NanoSpeed Series racquets! This string has original Carbon Nano Fiber that gives powerful repulsion and high durability.  ",
    price: "615",
    mrp: "481",
    discount: "22% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ybg65_1200_1.jpg",
    title: "YONEX BG 65 Badminton String",
    desc: "\nYONEX BG 65 : Multifilament Yonex string - Extreme Durability! ",
    price: "435",
    mrp: "350",
    discount: "20% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ybg68ti_1200_1.jpg",
    title: "YONEX BG68 Ti Badminton String",
    desc: "\nBG68 Ti: One of the most powerful string in the Yonex range! Delivering a very solid resonance on impact, it is designed for hard hitters as well as control player. Available in White ",
    price: "485",
    mrp: "390",
    discount: "20% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ybg66ultimax_1200_1.jpg",
    title: "YONEX BG66 Ultimax Badminton String",
    desc: "\nBG66 ULTIMAX :  It's the choice for the world's top players including Olympic and World Champion Taufik Hidayat (Indonesia) .\n\"The Sound from the Strings is great! Every shot feels so strong and powerful.\" - Taufiq Hidayat ",
    price: "525",
    mrp: "450",
    discount: "14% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ybg65ti_1200_1.jpg",
    title: "YONEX BG65 Ti Badminton String",
    desc: "\nMost popular Yonex string ! The High-quality Titanium gives it high-power repulsion and excellent shock-damping performance. Ideal string for high-tension stringing and aggressive tournament play. ",
    price: "470",
    mrp: "400",
    discount: "15% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/AXJE002.jpg",
    title: "Li-Ning NS30 Badminton String",
    desc: "High rigidity elastic string ",
    price: "460",
    mrp: "345",
    discount: "25% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/AXJE004.jpg",
    title: "Li-Ning NS50 Badminton String",
    desc: "\nPerfect combination of durability and repulsion power ",
    price: "670",
    mrp: "499",
    discount: "26% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTBG66FRL.jpg",
    title: "YONEX BG66 Force Badminton String",
    desc: "The repulsion power of a thin 0.65mm gauge string combined with excellent control allows for devastating, heavy smashes. ",
    price: "610",
    mrp: "520",
    discount: "15% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YNBGABWR.jpg",
    title: "YONEX BG AEROBITE Badminton String",
    desc: "Yonexâ€™s first ever hybrid string combo. The new AEROBITE applies heavy spin for decisive cut smashes or a solid touch for hairpins that drop straight down. ",
    price: "855",
    mrp: "599",
    discount: "30% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/YXBDSTBGAS.jpg",
    title: "YONEX Aero Sonic Badminton String",
    desc: "The yonex bg-as aerosonic badminton string is yonex thinnest string with a diameter of 0.61mm gauge ",
    price: "800",
    mrp: "680",
    discount: "15% off",
  },
  {
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CTBSTR005829.jpg",
    title: "Carlton Nanopulse 66 Badminton String Reel (200M, Red)",
    desc: "Carlton Nanopulse 66 Badminton String Reel (200M, Red) ",
    price: "8000",
    mrp: "3999",
    discount: "50% off",
  },
];
